import { useTranslation } from 'react-i18next'

import { translationMap } from 'locales'

export function useMappedTranslation() {
  const { t } = useTranslation()

  return (key: string, params?: object, defaultString?: string) => {
    const legacyKey = translationMap[key]
    let bundleText = legacyKey ? t(legacyKey, params) : t(key, params)

    if (bundleText === key || bundleText === legacyKey) {
      if (process.env.REACT_APP_ENV !== 'prod') {
        return `[MISSING] : ${key}`
      }
      return defaultString || ''
    }

    return bundleText
  }
}
